import { GameRepository } from "../../../../data/repository/game/GameRepository";
import { Message } from "../../../model/Auth";
import { UpdateGameRequestModel } from "../../../model/Game";
import { ResponseState, State } from "../../../model/ResponseState";

export interface UpdateGameUseCase {
  invoke: (model: UpdateGameRequestModel) => Promise<ResponseState<Message>>;
}

export class UpdateGameUseCaseImpl implements UpdateGameUseCase {
  private repo: GameRepository;

  constructor(repo: GameRepository) {
    this.repo = repo;
  }

  async invoke(model: UpdateGameRequestModel): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.updateGame(model);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
